import React, { useState, useEffect, useMemo } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import RightsCheck from "../General/RightsCheck";

const PrintTrialBalanceHeadWise = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [ClosingDebitTotal, setClosingDebitTotal] = useState("");
  const [ClosingCreditTotal, setClosingCreditTotal] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);

  const filters = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return {
      fyear:
        urlParams.get("fyear") ||
        localStorage.getItem("DefaultFYear") ||
        "",
      endDate: urlParams.get("endDate") || "",
      accountLevel:
        urlParams.get("accountLevel") ||
        urlParams.get("Accountlevel") ||
        "0",
      showZeroAccounts: urlParams.get("showZeroAccounts") !== "0",
      accountCode: (
        urlParams.get("accountCode") ||
        urlParams.get("AccountCode") ||
        ""
      ).trim(),
      accountName: (
        urlParams.get("accountName") ||
        urlParams.get("AccountName") ||
        ""
      ).trim(),
    };
  }, []);

  useEffect(() => {
    document.title = "Print Trial Balance Head Wise";
    setLoading(true);

    const year = parseInt(filters.fyear, 10);
    if (!year) {
      setLoading(false);
      return;
    }

    axios({
      method: "post",
      url: config.base_url + "Accounts/GetTrialBalanceHeadWise",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        pageNo: 1,
        pageSize: 10000,
        FYear: year,
        EndDate: filters.endDate,
        AccountLevel: parseInt(filters.accountLevel, 10) || 0,
        ShowZeroAccounts: filters.showZeroAccounts,
        AccountCode: filters.accountCode,
        AccountName: filters.accountName,
        ShowThirdOnly: false,
      },
    })
      .then((response) => {
        if (response.data?.status_code !== 0) {
          setLedger(
            Array.isArray(response.data?.ListofRecords)
              ? response.data.ListofRecords
              : []
          );
          setTotalRecords(response.data?.totalRecords ?? 0);
          setClosingDebitTotal(response.data?.ClosingDebitTotal ?? "");
          setClosingCreditTotal(response.data?.ClosingCreditTotal ?? "");
        } else {
          setLedger([]);
          setTotalRecords(0);
        }
      })
      .catch(() => setLedger([]))
      .finally(() => setLoading(false));
  }, [AccessKey, UserID, MemberType, filters]);

  const levelLabel =
    filters.accountLevel === "1"
      ? "1st Level"
      : filters.accountLevel === "2"
      ? "2nd Level"
      : filters.accountLevel === "3"
      ? "3rd Level"
      : "All Levels";

  const renderLedger = () => {
    if (listOfLedger != null && listOfLedger.length > 0) {
      return listOfLedger.map((item, index) => (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item.Selected_Account.Account_Code}</td>
          <td>{item.Selected_Account.Account_Description}</td>
          <td className="text-end">{item.ClosingDebit}</td>
          <td className="text-end">{item.ClosingCredit}</td>
        </tr>
      ));
    }

    return (
      <tr>
        <td colSpan="5" className="text-center text-muted">
          No Data Found
        </td>
      </tr>
    );
  };

  return (
    <>
      <RightsCheck />
      <Page orientation="portrait" size="a4">
        <table className="table table-sm table-bordered table-print">
          <thead>
            <tr>
              <th colSpan={5}>
                <PrintHeader title="Trial Balance Head Wise" />
              </th>
            </tr>
            <tr>
              <th colSpan={5}>
                Year: {filters.fyear} | Level: {levelLabel} | As on:{" "}
                {filters.endDate || "—"} | Zero accounts:{" "}
                {filters.showZeroAccounts ? "Yes" : "No"} | Records:{" "}
                {totalRecords}
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" className="text-center">
                  <Spinner animation="border" role="status" />
                </td>
              </tr>
            ) : (
              <>
                <tr>
                  <th>Sr.</th>
                  <th>Account Code</th>
                  <th>Account Name</th>
                  <th className="text-end">Closing Debit</th>
                  <th className="text-end">Closing Credit</th>
                </tr>
                {renderLedger()}
                <tr>
                  <td colSpan="3" className="text-end fw-bold">
                    Total
                  </td>
                  <td className="text-end fw-bold">{ClosingDebitTotal}</td>
                  <td className="text-end fw-bold">{ClosingCreditTotal}</td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </Page>
    </>
  );
};

export default PrintTrialBalanceHeadWise;
